<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <app-exact-overview></app-exact-overview>
    </app-sidebar>

    <app-content>
        <app-exact-not-logged-in (credentialsIsset)="checkCredentials($event)"></app-exact-not-logged-in>

        <div *ngIf="isset">
            <div class="app__title">
                <h1>Exact - Products</h1>
            </div>

            <app-searchbar [(value)]="filter"></app-searchbar>

            <div
                class="m-t-4"
                *appIsPermitted="{
                    module: 'EXACT',
                    operator: 'AND',
                    actions: ['READ']
                }">
                <table class="table-view">
                    <tr>
                        <th scope="col">Description</th>
                        <th scope="col">Stock</th>
                        <th scope="col">UnitDescription</th>
                        <th scope="col">ItemGroupDescription</th>
                        <th scope="col">Division number</th>
                    </tr>
                    <tr *ngFor="let item of items$ | async | orderBy: 'Description':false:true | filterBy: ['Description']:filter">
                        <td>
                            {{ item.Description }}
                        </td>
                        <td>
                            <span>{{ item.Stock }}</span>
                        </td>
                        <td>
                            <span class="tag">{{ item.UnitDescription }}</span>
                        </td>
                        <td>
                            <span>{{ item.ItemGroupDescription }}</span>
                        </td>
                        <td>
                            <span>{{ item.Division }}</span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </app-content>
</app-app-holder>
